<span
  *ngIf="!loading"
  [attr.data-test]="dataTestId"
  [matTooltip]="tooltip"
  [style.min-width]="minWidth ? (minWidth - 24).toString() + 'px' : 'unset'"
  class="hc-button__wrapper"
>
  <mat-icon
    *ngIf="leftIcon"
    [class.hc-button__left-icon]="leftIcon"
    svgIcon="{{ leftIcon }}"
  ></mat-icon>
  <span *ngIf="!isIconButton" class="content"><ng-content></ng-content></span>
  <mat-icon
    *ngIf="rightIcon && !isIconButton"
    [class.hc-button__right-icon]="rightIcon"
    svgIcon="{{ rightIcon }}"
  ></mat-icon
></span>
<div class="hc-button__wrapper">
  <app-spinner *ngIf="loading" [spinnerSize]="24"></app-spinner>
</div>
